import React from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import { changeCurrentOrder } from '../../Actions/changeCurrentOrder';
import Counter from './Counter';

const LastGood = props => {
  const { orderGoods, lastGoodId, changeOrder, t } = props;
  if (!lastGoodId) return null;
  const lastGood = R.filter(i => i.shopGood === lastGoodId, orderGoods);
  if (!lastGood.length || !lastGood[0].data) return null;
  const goodData = lastGood[0].data.locData[t.language];
  const image = lastGood[0].data.img;

  const delGood = goodId => {
    const changeGoods = orderGoods.map(i => {
      if (i.shopGood === goodId) {
        return { ...i, count: 0 };
      }
      return i;
    });
    changeOrder({ goods: changeGoods }, 0, 1);
  };

  return (
    <div className="product-sec">
      <img src={image.src} alt={image.alt} title={image.title} />
      <div className="info">
        <div>{goodData.name}</div>
        <div>{lastGood[0].cost}</div>
        <Counter good={lastGood[0]} />
      </div>
      <div
        className="delete-product"
        onClick={() => delGood(lastGood[0].shopGood)}
      >
        ×
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  orderGoods: state.currentOrder.order && state.currentOrder.order.goods,
  lastGoodId: state.app.lastGood,
  t: state.translation
});

const mapDispatchToProps = {
  changeOrder: changeCurrentOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(LastGood);
